import { PureComponent } from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { colors } from '../../constants'
import DEFAULT_SRC from '../../resources/mediaThumbnails/default.png'
import { MediaTypes, downloadThumbnail as downloadThumbnailAction, downloadMedia as downloadMediaAction } from '../../actions/content'
import Modal from '../Modal'
import { MediaUtils } from '../../utils'

const Frame = styled.div`
    position: relative;
    height: 100%;
    width: 100%;
`

const BackgroundPlayIcon = styled.div`
    position: absolute;
    height: 100%;
    width: 100%;
    cursor: pointer;
    z-index: 5;
`

const IconWrapper = styled.div`
    position: absolute;
    height: 20px;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
`

const Background = styled.img`
    opacity: 0.5;
    max-height: 100%;
`

const LoadingIcon = styled(FontAwesomeIcon)`
    color: ${colors.black};
`

const PlayIcon = styled(FontAwesomeIcon)`
    color: ${colors.white};
`

const Player = styled.video`
    height: auto;
    max-height: 80vh;
    width: 100%;
    max-width: 100%;
`

class Thumbnail extends PureComponent {
    static propTypes = {
        downloadThumbnail: PropTypes.func.isRequired,
        downloadMedia: PropTypes.func.isRequired,
        mediaId: PropTypes.number,
        withPlayer: PropTypes.bool,
        media: PropTypes.object,
    }

    static defaultProps = {
        mediaId: null,
        withPlayer: false,
        media: null,
    }

    state = {
        thumbnail: null,
        loading: true,
        isVideoPlayerOpen: false,
        videoPlayerUrl: null,
        content: null,
    }

    componentDidMount() {
        this.load()
    }

    componentDidUpdate = (prevProps) => {
        const { mediaId: prevMedia } = prevProps
        const { mediaId: newMedia } = this.props

        if (prevMedia !== newMedia) {
            this.load()
        }
    }

    downloadThumbnail = async () => {
        const { mediaId, downloadThumbnail } = this.props
        const response = await downloadThumbnail(mediaId)

        if (response.type === MediaTypes.DOWNLOAD_MEDIA_THUMBNAIL_SUCCESS) {
            this.setState({ thumbnail: response.payload })
        }

        this.setState({ loading: false })
    }

    playMedia = async () => {
        const { withPlayer } = this.props

        if (!withPlayer) {
            return null
        }

        const { mediaId, downloadMedia } = this.props
        const response = await downloadMedia(mediaId, true)

        if (response.type !== MediaTypes.DOWNLOAD_MEDIA_SUCCESS) {
            return null
        }

        const { payload: url } = response

        this.setState({ isVideoPlayerOpen: true, videoPlayerUrl: url })
    }

    get isVideo() {
        const { media } = this.props
        return MediaUtils.isVideo(media)
    }

    downloadMedia = async () => {
        const { media, downloadMedia } = this.props
        const response = await downloadMedia(media.id, true)

        if (response.type === MediaTypes.DOWNLOAD_MEDIA_SUCCESS) {
            this.setState({ content: response.payload })
        }
        this.setState({ loading: false })
    }

    get thumbnailSource() {
        const { content, thumbnail } = this.state
        return (this.isVideo ? thumbnail : content) || DEFAULT_SRC
    }

    load = async () => {
        const { isVideo } = this
        this.setState({ thumbnail: null, loading: true }, () => {
            if (isVideo) {
                this.downloadThumbnail()
            } else {
                this.downloadMedia()
            }
        })
    }

    renderVideoPlayer() {
        const { isVideoPlayerOpen, videoPlayerUrl } = this.state
        return (
            <Modal isOpen={isVideoPlayerOpen} onClose={() => this.setState({ isVideoPlayerOpen: false })} minWidth="50%">
                <Player controls controlsList="nodownload" autoPlay disablePictureInPicture onContextMenu={(e) => e.preventDefault()}>
                    <track kind="captions" />
                    <source src={videoPlayerUrl} />
                </Player>
            </Modal>
        )
    }

    render() {
        const { withPlayer } = this.props
        const { loading } = this.state
        return (
            <Frame>
                <BackgroundPlayIcon onClick={this.playMedia}>
                    <IconWrapper>
                        {loading && <LoadingIcon icon="spinner" pulse spin />}
                        {!loading && withPlayer && <PlayIcon icon="play" />}
                    </IconWrapper>
                </BackgroundPlayIcon>
                <Background src={this.thumbnailSource || DEFAULT_SRC} alt="media" />
                {withPlayer && this.renderVideoPlayer()}
            </Frame>
        )
    }
}

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            downloadThumbnail: downloadThumbnailAction,
            downloadMedia: downloadMediaAction,
        },
        dispatch
    )

export default connect(null, mapDispatchToProps)(Thumbnail)
